import './index.styl';
import _ from 'lodash';
import { CollectionView } from 'backbone.marionette';
import PlayerPoolView from "../Player";
import EmptyPlayerPoolView from "../Player/Empty";
import { Players } from '../../../../collections';
import { FantasyTeam } from '../../../../models';

const {
	filter_by_name,
	filter_by_price,
	filter_by_squad,
	filter_by_position,
	filter_dpp_only,
	filter_favourite_only,
	filter_available_only
} = Players;

export class PlayerPoolList extends CollectionView {
	get tagName() {
		return 'ul';
	}

	get childView() {
		return PlayerPoolView;
	}

	get emptyView() {
		return EmptyPlayerPoolView;
	}

	childViewTriggers() {
		return {
			'player:add': 'player:add',
			'player:show:popup': 'player:show:popup'
		}
	}

	childViewOptions(model) {
		const
			default_keys = new Set(['cost', 'name']),
			coach_keys = new Set(['stats.break_even', 'stats.proj_score']),
			stats_key = default_keys.has(this.order_by) ? 'stats.avg_points' : this.order_by;

		model.set({
			sorted_stats: _.result(model.attributes, stats_key),
			is_coach_stats: coach_keys.has(stats_key)
		}, { silent: true });
	}

	initialize() {
		this.team = new FantasyTeam();
		this.order_by = 'cost';
		this.is_asc_order = false;
		this.collection = new Players();
	}

	viewComparator(a_model, b_model) {
		const
			order = this.is_asc_order ? 1 : -1,
			minimal = 99999 * order,
			getResult = (condition, min, value) => condition(value) ? min : value,
			isStringOrZero = val => _.isString(val) || _.eq(val, 0);

		let
			is_bigger, is_less,
			a_result = _.result(a_model.attributes, this.order_by),
			b_result = _.result(b_model.attributes, this.order_by);

		switch (this.order_by) {
			case 'name':
				const
					a_name = a_model.get("last_name"),
					b_name = b_model.get("last_name");

				is_bigger = a_name < b_name;
				is_less = a_name > b_name;

				break;
			case 'stats.cost_divided_by_points':
				{
					const getResultOrMin = _.partial(getResult, isStringOrZero, minimal * -1);
					a_result = getResultOrMin(a_result);
					b_result = getResultOrMin(b_result);
				}

				is_bigger = a_result < b_result;
				is_less = a_result > b_result;

				break;
			default:
				{
					const getResultOrMin = _.partial(getResult, _.isString, minimal);
					a_result = getResultOrMin(a_result);
					b_result = getResultOrMin(b_result);
				}

				is_bigger = a_result > b_result;
				is_less = a_result < b_result;

				break;
		}

		if (is_bigger) {
			return order;
		}

		if (is_less) {
			return -1 * order;
		}

		return 0;
	}

	init(args) {
		const {
			players,
			team,
			remaining_salary,
			is_mobile_view,
			selected_position,
			is_coach_enabled,
			has_assistant_coach,
			next_round_id,
			quick_trade,
		} = args;

		const
			trade_out_player = _.first(quick_trade),
			has_trade = Boolean(trade_out_player);

		this.team.set(team);

		const players_list = _.chain(players)
			.filter(
				player => !this.team.team_players_id.includes(player.id)
			)
			/*eslint-disable */
			.map(player => {
				const is_out_of_budget = (remaining_salary - player.cost) < 0;

				let is_locked = player.is_locked ||	is_out_of_budget;

				if(has_trade) {
					is_locked = (
						is_locked ||
						!player.positions.some(
							pos => trade_out_player.possible_positions.includes(pos)
						)
					);
				}
				else {
					is_locked = (
						is_locked ||
						this.team.is_filled ||
						this.team.isPositionsFilled(player.positions)
					);
				}

				if (is_mobile_view && !is_locked && !has_trade) {
					const
						positions = [...player.positions, 'bench'],
						is_from_selected_position = positions.includes(selected_position),
						is_selected_position_filled = (
							is_from_selected_position &&
							this.team.isPositionsFilled([selected_position], true)
						);

					is_locked = !is_from_selected_position || is_selected_position_filled;
				}

				return {
					...player,
					is_locked,
					is_coach_enabled,
					has_assistant_coach,
					next_round_id
				}
			})
			/*eslint-enable */
			.value();

		this.collection.reset(players_list);

		return this;
	}

	get filtersList() {
		return {
			filter_by_name,
			filter_by_price,
			filter_by_squad,
			filter_by_position,
			filter_dpp_only,
			filter_favourite_only,
			filter_available_only
		}
	}

	combineFilters(filters) {
		return (model, index, collection) => {
			return filters.every(filter => filter(model, index, collection));
		}
	}

	filterBy({ order_by, is_asc_order = false, ...filtersArgs }) {
		this.order_by = order_by || this.order_by || 'cost';
		this.is_asc_order = is_asc_order;

		this.filters = filtersArgs;

		let filter_names = _.keys(filtersArgs),

			filter_funcs = _.pick(this.filtersList, filter_names),

			filtersArray = _.map(filter_funcs, (filterFunc, name) => {
				const filter_argument = _.get(filtersArgs, name);

				return filterFunc.bind(this, filter_argument);
			});

		this.setFilter(
			this.combineFilters(filtersArray),
			{ preventRender: true }
		);

		this.collection.trigger('reset');

		return this;
	}
}

export default PlayerPoolList;